import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader';
import { Link, withAssetPrefix } from 'gatsby';
import { LocationProvider, navigate } from '@reach/router';
import { Helmet } from 'react-helmet';

import { Layout, Header, Footer, Search, SearchResult, Nav } from 'components';
import { Heading } from 'elements';
import { classname } from 'utils';

import './App.css';

LocationProvider.defaultProps.history.listen(() => {
  window.isHistory = true;
});

/**
 * Приложение
 */
class App extends Component {
  cl = classname('app');

  constructor(props) {
    super(props);

    this.state = {
      search: ''
    };
  }

  static propTypes = {
    /** Показать кнопку назад */
    back: PropTypes.bool,
    /** Показать блок навигации */
    nav: PropTypes.bool,
    /** Заголовок */
    heading: PropTypes.string,
    /** Показывать поле поиска */
    search: PropTypes.bool,
    /** Содержимое */
    children: PropTypes.node
  };

  static defaultProps = {
    search: true
  };

  /**
   * Событие поиска
   * @param value
   */
  onSearch(value) {
    this.setState({
      search: value
    });
  }

  /**
   * Вернуться назад
   */
  onClickBack(event) {
    const { search } = this.state;

    if (!search) {
      if (window.isHistory) {
        window.history.back();
      } else {
        navigate('/');
      }
    } else {
      this.setState({
        search: ''
      });
    }

    event.preventDefault();
  }

  componentDidMount() {
    if (process.browser) {
      this.setState({
        height: this.content.clientHeight
      });
    }
  }

  render() {
    const { children, heading, nav, back, id, search, section } = this.props;

    return (
      <Layout>
        <Helmet>
          <meta name="description" content="Карта IT-решений для реализации задач интернет-маркетинга" />
          <link rel="apple-touch-icon" sizes="180x180" href={withAssetPrefix('/favicons/apple-touch-icon.png')} />
          <link rel="icon" type="image/png" sizes="32x32" href={withAssetPrefix('/favicons/favicon-32x32.png')} />
          <link rel="icon" type="image/png" sizes="16x16" href={withAssetPrefix('/favicons/favicon-16x16.png')} />
          <link rel="shortcut icon" href={withAssetPrefix('/favicons/favicon.ico')} />
          <meta name="msapplication-TileColor" content="#57a7dd" />
          <meta name="msapplication-config" content={withAssetPrefix('/favicons/browserconfig.xml')} />
          <meta name="theme-color" content="#ffffff" />
          <meta property="og:site_name" content="AdIndex. Technology Map 2020" />
          <meta property="vk:image" content={withAssetPrefix('/og-s.png')} />
          <meta property="twitter:image" content={withAssetPrefix('/og-l.png')} />
          <meta property="og:image" content={withAssetPrefix('/og-l.png')} />
          <meta property="og:image:width" content="600" />
          <meta property="og:image:height" content="315" />
          <link rel="image_src" href={withAssetPrefix('/og-l.png')} />
          <meta name="twitter:card" content="summary_large_image" />
        </Helmet>
        <div className={this.cl('wrapper')}>
          <Header />
          <div
            className={this.cl('content')}
            ref={node => (this.content = node)}
            style={this.state.height ? { minHeight: this.state.height + 'px' } : null}
          >
            {nav && !this.state.search && (
              <div className={this.cl('nav')}>
                <Nav {...{ id, section }} />
              </div>
            )}
            {(back || this.state.search) && (
              <div className={this.cl('back')}>
                <Link to={'/'} className={this.cl('back')} onClick={event => this.onClickBack(event)}>
                  Назад
                </Link>
              </div>
            )}
            <div className={[this.cl('inner'), this.props.isMain ? this.cl('inner-main') : ''].join(' ')}>
              {!this.state.search ? (
                <>
                  {heading && (
                    <div className={this.cl('heading')}>
                      <Heading>{heading}</Heading>
                    </div>
                  )}
                  {children}
                </>
              ) : (
                <>
                  <div className={this.cl('search-heading')}>
                    <Heading>Результаты поиска</Heading>
                  </div>
                  <SearchResult search={this.state.search} />
                </>
              )}
            </div>
            {search && (
              <div className={this.cl('search')}>
                <Search value={this.state.search} onChange={value => this.onSearch(value)} />
              </div>
            )}
          </div>
          <Footer />
        </div>
      </Layout>
    );
  }
}

export default hot(module)(App);
